module.exports = __webpack_public_path__ + "static/media/lamina17fondo.096209af.png";